const modes = {
    light: 1,
    dark: 2,
    system: 3
  }

const THEME_MODE = "current_theme";

  export {
    modes,
    THEME_MODE
  };